// Dependencies
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';

// Models
import { OrganizationModel } from '../../../models/organization.model';
import { StudyModel } from '../../../models/study.model';

// Services
import { StudyContainerPageService } from '../../study-container-page/study-container-page.service';

@Component({
    selector: 'organization-list-page',
    templateUrl: './organization-list-page.component.html',
    styleUrls: ['./organization-list-page.component.scss']
})
export class OrganizationListPageComponent {
    constructor(private studyContainerPageService: StudyContainerPageService) {}


    //---------------------------------
    // Lifecycle Hooks
    //---------------------------------

    ngOnInit() {
    }


    //---------------------------------
    // Public
    //---------------------------------


    //---------------------------------
    // Private
    //---------------------------------

}


// WEBPACK FOOTER //
// ./src/app/pages/study-container-page/organization-list-page/organization-list-page.component.ts